export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const { isLoggedIn, user } = storeToRefs(userStore)

  const logoutTimeout = ref<ReturnType<typeof setTimeout>>()

  watch(isLoggedIn, (loggedIn) => {
    clearTimeout(logoutTimeout.value)

    if (!loggedIn || !user.value?.exp) {
      return
    }

    const millisecondsUntilExpiry = Math.max(user.value.exp * 1000 - Date.now(), 0)

    logoutTimeout.value = setTimeout(userStore.clearUserForLogout, millisecondsUntilExpiry)
  }, { immediate: true })
})
